import { CALL_API } from '../middleware/ApiMiddleware';
import { LOGIN_API, LOGOUT_API } from '../middleware/AuthMiddleware';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const SUPER_ADMIN_AGENCY_LOGIN = 'SUPER_ADMIN_AGENCY_LOGIN';

export const GET_REFRESH_TOKEN_REQUEST = 'GET_REFRESH_TOKEN_REQUEST';
export const GET_REFRESH_TOKEN_SUCCESS = 'GET_REFRESH_TOKEN_SUCCESS';
export const GET_REFRESH_TOKEN_FAILURE = 'GET_REFRESH_TOKEN_FAILURE';

export const loginRequest = (
  email: string,
  password: string,
  agencyId: number,
  idToken?: string,
  accessToken?: string
) => ({
  [LOGIN_API]: {
    email,
    password,
    agencyId,
    idToken,
    accessToken,
    errorDismissible: true,
    types: [LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE],
  },
});

export const loginSuccess = (userProfile: IUserProfile) => ({
  type: LOGIN_SUCCESS,
  userProfile,
});

export const logoutRequest = () => ({
  [LOGOUT_API]: {
    success: LOGOUT_SUCCESS,
  },
});

export const logOut = () => ({
  type: LOGOUT_SUCCESS,
});

export const loginStaffRequest = (agencyId: number, username: string, password: string) => ({
  [LOGIN_API]: {
    username,
    password,
    agencyId,
    types: [LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE],
  },
});

export const getRefreshToken = () => ({
  [CALL_API]: {
    endpoint: 'refresh-token',
    method: 'get',
    authenticated: true,
    types: [GET_REFRESH_TOKEN_REQUEST, GET_REFRESH_TOKEN_SUCCESS, GET_REFRESH_TOKEN_FAILURE],
  },
});

export const superAdminAgencyLogin = (jwtToken: string) => ({
  type: SUPER_ADMIN_AGENCY_LOGIN,
  payload: jwtToken,
});
